import { createLogger } from "@/utils/logger";

import {
  convertLatexToExpression,
  findLatexMarkersInTextNodes,
  findLatexPairs,
  shouldExcludeNodeFromLatexConversion,
} from "./utils";

import type { LatexMarker } from "./types";
import type { DocumentModel } from "@/models/DocumentModel";
import type { Node as ProseMirrorNode } from "@tiptap/pm/model";
import type { EditorView } from "@tiptap/pm/view";

const logger = createLogger("LatexInput");

/**
 * Scan the entire document for $...$ and $$...$$ patterns and convert valid ones to expressions
 */
export function scanAndConvertLatexOnInit(view: EditorView, docModel: DocumentModel) {
  const { state } = view;
  const conversions: Array<{ start: LatexMarker; end: LatexMarker; latex: string }> = [];

  state.doc.descendants((node: ProseMirrorNode, pos: number) => {
    if (shouldExcludeNodeFromLatexConversion(node)) return;

    const blockStart = pos + 1; // +1 to account for opening tag
    const blockEnd = pos + 1 + node.content.size;

    const markers = findLatexMarkersInTextNodes(node, blockStart);
    const pairs = findLatexPairs(markers, state.doc, blockEnd, blockEnd);

    for (const pair of pairs) {
      const { start, end, content } = pair;

      if (end && content.trim()) {
        conversions.push({
          start,
          end,
          latex: content,
        });
      }
    }
  });

  // Convert in reverse order to maintain positions
  for (let i = conversions.length - 1; i >= 0; i--) {
    const { start, end, latex } = conversions[i];

    try {
      convertLatexToExpression(latex, start, end, docModel);
    } catch (error) {
      logger.debug("Failed to convert LaTeX on init:", latex, error);
    }
  }
}
